<div class="c-dialog__icon" [ngClass]="config.theme" *ngIf="config.icon">
    <ihd-icon name="{{config.icon}}" class="mod-xlg"></ihd-icon>
</div>
<ihd-dialog-title>{{ config.title | translate }}</ihd-dialog-title>
<ihd-dialog-body [formGroup]="verificationForm" [ihdFormSubmitted]="submitted">
    <div class="mb-5"> {{config.content | translate: config.contentParams}}</div>
    <div class="ml-6 mr-6">
        <input type="text"
               class="c-form-control"
               formControlName="verificationCode"
               (keydown.enter)="verify()">
        <ihd-form-messages [form]="verificationForm" name="verificationCode" [submitted]="submitted">
            <ihd-form-message name="required">{{'HelpHint.Required' | translate: { name: helpHintName } }}
            </ihd-form-message>
            <ihd-form-message name="minlength">{{'HelpHint.MinLength' | translate: { name: helpHintName,  length: minLength} }}
            </ihd-form-message>
            <ihd-form-message name="maxlength">{{'HelpHint.MaxLength' | translate: { name: helpHintName,  length: maxLength}  }}
            </ihd-form-message>
        </ihd-form-messages>
    </div>
</ihd-dialog-body>
<ihd-dialog-actions>
    <ihd-button-group class="c-btn-group--gap-4 justify-content-center ">
        <button ihdButton type="button"
                class="c-btn--base c-btn--wlg c-btn--lg"
                ihdDialogClose
                [disabled]="isClosing">
            {{'Common.Cancel'|translate}}
        </button>
        <button ihdButton type="button"
                class="c-btn--primary c-btn--wlg c-btn--lg"
                (click)="verify()"
                [disabled]="isClosing">
            {{'Common.Verify'|translate}}
        </button>
    </ihd-button-group>
</ihd-dialog-actions>
